// extracted by mini-css-extract-plugin
export default {"ContactTitle":"styles_ContactTitle__gnTSl","ContactContainer":"styles_ContactContainer__InDNs"};